export default {
  title: "Каталоги онлайн",
  tabs: {
    products: "Молу хизматрасониҳо",
    categories: "Категориҳо",
  },
  buttons: {
    qrCode: "QR-рамз",
    create: "Эҷод кардан",
  },
  modals: {
    limit: {
      title: "Шумо дар тарифи худ ҳадди аксари маҳсулотро эҷод кардед",
      subtitle: "Барои эҷоди маҳсулоти бештар, тарифи худро боло баред.",
      cancel: "Бекор кардан",
      toTariffs: "Ба тарифҳо",
    },
  },
  statuses: {
    allProducts: "Ҳамаи маҳсулот",
    allCategories: "Ҳамаи категориҳо",
    confirmed: "Таъйидшуда",
    moderation: "Дар модератсия",
    rejected: "Радшуда",
    basic: "Асосӣ",
  },
  emptyState: {
    products: {
      noTradingPoints: {
        title: "То ҳол маҳсулот дар каталоги онлайн нестанд",
        description:
          "Аввал нуқти тиҷоратӣ эҷод кунед, баъд маҳсулот илова карда мешаванд",
        buttonText: "Ба нуқатҳои тиҷоратӣ",
      },
      noProducts: {
        title: "То ҳол маҳсулот дар каталоги онлайн нестанд",
        buttonText: "Эҷоди маҳсулот",
      },
    },
    categories: {
      title: "То ҳол маълумот нестанд",
      description:
        "Онҳо пас аз эҷоди маҳсулот ва пайвастани он ба яке аз категориҳои асосӣ дар ин ҷо пайдо мешаванд. Ё пас аз эҷоди категории корбарӣ.",
      buttonText: "Эҷоди категория",
    },
  },
  formErrors: {
    empty: "Майдон холӣ набошад",
    price: "Қимати зиёдтар аз 0 зарур аст",
    discount: "Қимати камтар аз нархи бе тахфиф зарур аст",
  },
  exitModal: {
    creating: {
      title: "Эҷоди маҳсулот бекор карда шавад?",
      subtitle:
        "Маълумоти воридшуда дар бораи маҳсулот захира нахоҳад шуд. Барои бозгашт ба таҳрир, тугмаи «Бозгашт»-ро пахш кунед.",
      backButton: "Бозгашт",
      confirmButton: "Ҳа, бекор кардан",
    },
    editing: {
      title: "Тағироти воридшуда нест карда шаванд?",
      subtitle:
        "Агар зарур аст, ки онҳо захира шаванд, бозгардед. Дар акси ҳол, ҳама тағироти воридшуда татбиқ нахоҳанд шуд. Дар корти маҳсулот маълумоти пештара захирашуда намоиш дода мешаванд.",
      backButton: "Бозгашт ва захира кардан",
      confirmButton: "Нест кардан",
    },
  },
  categoryEditModal: {
    title: {
      rejected: "Категория аз тарафи модератор рад шуд",
      default: "Номи категорияро ишора кунед",
    },
    subtitle: {
      rejected: "Номро тағир диҳед ва категориро ба модератсия фиристед.",
      rejectedWithMessage:
        "Номро тағир диҳед ва категориро ба модератсия фиристед.",
      default:
        "Категория пас аз гузаронидани модератсия барои интихоб дар эҷоди маҳсулоти нав дастрас мешавад ва бо номи ишорашуда дар RC PAY намоиш дода мешавад.",
    },
    buttons: {
      cancel: "Бекор кардан",
      sendForModeration: "Ба модератсия",
    },
    notification: {
      success: "Категория ба модератсия фиристода шуд",
    },
  },
  categoryDeleteModal: {
    title: "Мутмаин ҳастед, ки мехоҳед категорияи «{name}»-ро нест кунед?",
    subtitle:
      "Ба маҳсулоте, ки ба он вобастаанд, қимати асосии «Бе категория» таъин карда мешавад",
    buttons: {
      cancel: "Бекор кардан",
      delete: "Нест кардан",
    },
    notification: {
      deleted: "Категория нест карда шуд",
    },
  },
  productCard: {
    labels: {
      name: "Номи маҳсулот",
      category: "Категория",
      measurementUnit: "Воҳиди ченак",
      price: "Нарх, {currency}",
      discountPrice: "Нарх бо тахфиф, {currency}",
      sku: "Артикул",
      barcode: "Баркод",
      description: "Тавсиф",
      tradingPointsVisibility: "Намоиш дар нуқатҳои тиҷоратӣ",
      productImages: "Аксҳои маҳсулот",
      showInCatalog: "Маҳсулотро дар Каталоги онлайн намоиш додан",
      showInCatalogDescription:
        "Маҳсулот пас аз гузаронидани модератсия дар RC PAY дар Каталоги онлайн нуқатҳои тиҷоратии интихобшуда намоиш дода мешавад.",
    },
    placeholders: {
      selectCategory: "Категорияро интихоб кунед",
      selectMeasurementUnit: "Воҳиди ченакро интихоб кунед",
      sku: "то 30 аломат",
      selectTradingPoints: "Нуқатҳои тиҷоратиро интихоб кунед",
    },
    buttons: {
      cancel: "Бекор кардан",
    },
    notifications: {
      fillRequiredFields: "Ҳамаи майдонҳои ҳатмиро дуруст пур кунед",
      savedAndSentForModeration:
        "Тағирот захира ва ба модератсия фиристода шуданд",
      successfullySaved: "Тағирот бо муваффақият захира шуданд",
    },
    moderationMessage: {
      title: "Паём аз модератсия",
    },
    measurementUnits: {
      none: "Бе воҳиди ченак",
    },
    imageRequirements: {
      aspectRatio: "Нисбати тарафҳои акс — 1:1",
      fileTypes: "JPEG, JPG, PNG — то 5 файл, ҳар яке то 10 Мб",
    },
    imageCropper: {
      subtitle:
        "Минтақаи интихобшуда дар корти маҳсулот дар Каталоги онлайн дар RC PAY намоиш дода мешавад.",
    },
  },
  productsTableHeader: {
    columns: {
      name: "Ном",
      category: "Категория",
      price: "Нарх",
      status: "Ҳолат",
    },
  },
  productsDeleteModal: {
    title: "Мутмаин ҳастед, ки мехоҳед маҳсулоти ишорашударо нест кунед?",
    buttons: {
      cancel: "Бекор кардан",
      delete: "Нест кардан",
    },
  },
  productsQRModal: {
    title: "QR-рамз ба меню",
    subtitle:
      "Нуқти тиҷоратиеро интихоб кунед, ки мехоҳед QR-рамзи каталоги онлайн-и онро боргирӣ кунед",
    tradingPoint: "Нуқти тиҷоратӣ",
    downloadButton: "Боргирии QR-рамз",
  },
  productsSaveModal: {
    title: "Баъзе аз тағироти воридшуда модератсия талаб мекунанд",
    subtitle:
      "Онҳо дар корти маҳсулот, ки дар RC PAY намоиш дода мешавад, танҳо пас аз санҷиш ва таъйиди модератор нав карда мешаванд.",
    buttons: {
      cancel: "Бекор кардан",
      sendForModeration: "Ба модератсия",
    },
  },
  productVisible: {
    messages: {
      visible: "Дар RC PAY намоиш дода мешавад",
      hidden: "Дар RC PIN пинҳон аст",
    },
  },
  categoriesFilters: {
    sort: {
      newFirst: "Аввал навтарин эҷодшуда",
      alphabeticalAsc: "Аз A то Я",
      alphabeticalDesc: "Аз Я то A",
      productsCountAsc: "Аввал маҳсулоти камтар",
      productsCountDesc: "Аввал маҳсулоти бештар",
    },
    buttons: {
      create: "Эҷод кардан",
    },
    search: {
      placeholder: "Ҷустуҷӯ аз рӯи категориҳо",
    },
    status: {
      label: "Ҳолати категория",
    },
  },
  productFilters: {
    sort: {
      newFirst: "Аввал навтарин эҷодшуда",
      alphabeticalAsc: "Аз A то Я",
      alphabeticalDesc: "Аз Я то A",
      priceAsc: "Нарх афзоишӣ",
      priceDesc: "Нарх коҳишӣ",
    },
    buttons: {
      create: "Эҷод кардан",
    },
    search: {
      placeholder: "Ҷустуҷӯ",
    },
    labels: {
      category: "Категория",
      tradingPoints: "Нуқатҳои тиҷоратӣ",
      status: "Ҳолат",
    },
  },
  productDrawer: {
    title: {
      edit: "Маълумот дар бораи маҳсулот",
      create: "Эҷоди маҳсулот",
    },
    saveButton: {
      saveAndExit: "Захира кардан ва баромадан",
      sendForModeration: "Ба модератсия",
    },
    errors: {
      imageUpload:
        "Баъзе аксҳо коркард нашданд. Кӯшиш кунед, ки аксҳои дигарро бор кунед.",
    },
  },
};
